<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card v-if="dialog">
        <v-card-title>
          <span class="text-h5">{{ title }}</span>
          <v-spacer />
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
<!--             <small v-if="error" style="color: red">Es Nutzer mit dieser ID wurde bereits einem anderen Mandanten zugeordnet</small> -->
            <v-form v-model="valid" ref="form">
              <v-row>
              <v-col cols="12">
                <v-text-field
                  label="Nutzer-ID (Email)*"
                  :rules="rules.required"
                  hint="Geben Sie hier eine E-Mail-Adresse ein"
                  persistent-hint
                  v-model="newUser.userId"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  label="Vorname*"
                  :rules="rules.required"
                  v-model="newUser.firstName"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  label="Nachname*"
                  :rules="rules.required"
                  v-model="newUser.lastName"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
              >
                <v-select
                v-model="newUser.roles"
                :items="roles"
                :rules="[(v) => !!v || 'Rolle muss angegeben werden']"
                label="Rolle"
                item-text="roleTitle"
                required
                chips
                multiple
              ></v-select>
              </v-col>
              <v-col
                cols="12"
              >
                <v-color-picker
                    dot-size="25"
                    mode="hex"
                    v-model="color"
                ></v-color-picker>
                <span class="mr-6">Farbcode: {{color.substring(0,7)}}</span>|
                  <v-btn color="secondary" text elevation="0" @click="resetColor">
                      <v-icon>mdi-refresh</v-icon>
                      Andere Farbe
                  </v-btn>
              </v-col>
            </v-row>
            </v-form>
          </v-container>
          <small>*zeigt benötigte Felder an</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
                    text
                    @click="close"
                    id="leftButton"
            >
              Abbrechen
          </v-btn>
          <v-btn
            v-if="!editMode"
            color="primary"
            elevation="0"
            @click="submitUser()"
            id="rightButton"
          >
            Nutzer anlegen
          </v-btn>
          <v-btn
            v-if="editMode"
            color="primary"
            elevation="0"
            @click="editUser()"
            id="rightButton"
          >
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar location="center" rounded="pill" v-model="snackbar.value" outlined timeout="-1" :color="snackbar.status" class="mb-12">
  
      <span class="middle-aligned">
        <v-progress-circular
        v-if="snackbar.loading"
        indeterminate
        :color="snackbar.status"
      ></v-progress-circular>
      <v-icon v-if="snackbar.icon" :color="snackbar.status">{{ snackbar.icon }}</v-icon>
      {{ snackbar.msg}}
      </span>

    </v-snackbar>
  </v-row>
</template>

<script>
import roleService from "@/pages/UserManagement/roleService"
import userService from "@/components/userService"
  export default {
    data: () => ({
      dialog: false,
      roles:[],
      resolve: null,
      reject: null,
      title: "Neuen Nutzer anlegen",
      rules: {
        email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        required: [value => !!value || "Muss ausgefüllt werden"]
      },
      newUser: {
        firstName: null,
        lastName: null,
        roles: [],
        userId: null,
      },
      error: false,
      valid: true,
      editMode: false,
      color: '',
      snackbar: {
        value: false,
        status: "secondary",
        msg: "",
        loading: false,
        icon: null
      }
    }),
    methods:{
      resetData(){
        this.newUser = {
          firstName: null,
          lastName: null,
          roles: [],
          userId: null,
          iconColor: ''
        }
        this.error = false;
        this.roles = [];
        this.color = '';
        this.snackbar = {
          value: false,
          status: "secondary",
          msg: "",
          loading: false,
          icon: null
        }
      },
      open(user) {
        if(user != null){
          this.newUser = JSON.parse(JSON.stringify(user)); //deepclone
          this.editMode = true;
          let initUserColor = Math.floor(Math.random()*16777215).toString(16);
          this.color = initUserColor;
          this.color = this.color.substring(0,7)
          if(user.iconColor != null) this.color = user.iconColor;
        } else {
          let initUserColor = Math.floor(Math.random()*16777215).toString(16);
          this.color = initUserColor;
          this.color = this.color.substring(0,7)
        }
        roleService.retrieveRoles().then((res) => {
          this.roles = res.data;
          this.dialog = true;
        });
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },
      submitUser() {
        if(this.$refs.form.validate()){
          this.newUser.iconColor = this.color.substring(0,7);
          this.snackbar = {
              value: true,
              status: "secondary",
              msg: "Nutzer wird hinzugefügt",
              loading:true
            }
          userService.addUser(this.newUser).then(() => {
            this.snackbar = {
              value: true,
              status: "success",
              msg: "Nutzer erfolgreich hinzugefügt",
              loading: false,
              icon: "mdi-account-check"
            }
            setTimeout(() => {
              this.resolve();
              this.resetData();
              this.dialog = false;
            }, 3000);
            
          })
          .catch(e => {
            this.error = true;
            this.snackbar = {
              value: true,
              status: "error",
              msg: "Es ist ein Fehler aufgetreten",
              loading: false,
              icon: "mdi-account-remove"
            }
          });
        }
      },
      editUser(){
        this.$delete(this.newUser, 'fullName');
        this.newUser.iconColor = this.color.substring(0,7);
        userService.editUser(this.newUser).then((res) => {
          if(res.data == false) alert("Beim Bearbeiten ist ein Fehler aufgetreten. Möglicherweise besteht schon ein Nutzer mit dieser E-Mail-Adresse")
          this.resolve();
          this.resetData();
          this.dialog = false;
        });
      },
      close(){
        this.reject();
        this.resetData();
        this.dialog = false;
      },
      resetColor() {
        let initUserColor = Math.floor(Math.random()*16777215).toString(16);
        this.color = initUserColor;
      }
    }
  }
</script>
<style scoped>
:deep .v-color-picker__sliders > div:nth-child(2){
  display: none;
}
.middle-aligned {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}
</style>